module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/letter-5a3825.png";